var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"a-youtube",class:{ 'a-youtube--modal': _vm.isModal },attrs:{"id":_vm.iframeId,"src":_vm.src,"data-src":_vm.src,"data-title":_vm.title,"allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }